<div class="grid-container" *ngIf="specialOffer">
    <div class="main-card">
        <div class="card mb-5">
            <div class="card-body">
                <div class="campaign-header">
                    <div class="brand text-secondary fw-semibold">{{ specialOffer.manufacturerName }}</div>
                    <div>
                        @switch (specialOffer.status) {
                            @case (specialOfferStatus.ONGOING) {
                                <span HJSuppress class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                    {{'specialOffers.statusMessage.ongoing' | translate}}
                                </span>
                            }
                            @case (specialOfferStatus.UPCOMING) {
                                <span HJSuppress class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                    {{'specialOffers.statusMessage.upcoming' | translate}}
                                </span>
                            }
                            @case (specialOfferStatus.ENDED) {
                                <span HJSuppress class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                    {{'specialOffers.statusMessage.ended' | translate}}
                                </span>
                            }
                            @case (specialOfferStatus.DRAFT) {
                                <span HJSuppress class="status-badge" [ngClass]="specialOffer.status.toLowerCase()">
                                    {{'specialOffers.statusMessage.draft' | translate}}
                                </span>
                            }
                        }
                    </div>
                </div>

                <!-- Campaign Title, Price, StartDate, Expire in -->
                <div [ngClass]="{ 'content-box': true, 'dotted-border-box': specialOffer.status === specialOfferStatus.DRAFT ||
                    specialOffer.status === specialOfferStatus.UPCOMING}">
                    <div class="campaign-title-price">
                        <div>
                            <h2 HJSuppress class="campaign-title fw-bold">{{ specialOffer.title }}</h2>
                            <div class="price">
                                <span
                                    HJSuppress
                                    class="price-value text-primary fw-bold">
                                    {{ specialOffer.assetPrice }} {{ specialOffer.currencyCode }}
                                </span>
                                <span
                                    HJSuppress
                                    class="price-vat">
                                    {{
                                        specialOffer.assetPriceWithVat
                                        ? ('specialOffers.preview.information.withVAT' | translate)
                                        : ('specialOffers.preview.information.withoutVAT' | translate)
                                    }}
                                </span>
                            </div>

                            <div *ngIf="specialOffer.status === specialOfferStatus.ENDED" class="campaign-dates mb-2">
                                <div class="date-item">
                                    <span class="text-secondary"> {{ 'specialOffers.preview.information.startDate' | translate }}</span>
                                    <span HJSuppress class="fw-semibold">{{ specialOffer.startDate | localizedDate }}</span>
                                </div>
                                <div class="date-item">
                                    <span class="text-secondary">{{ 'specialOffers.preview.information.endDate' | translate }}</span>
                                    <span HJSuppress class="fw-semibold text-danger">{{ countdown$ | async }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="(specialOffer.status === specialOfferStatus.DRAFT) || (specialOffer.status ===specialOfferStatus.UPCOMING)"
                        role="button"
                        tabindex="0"
                        class="edit-container"
                        (click)="editSection(specialOfferRoutes.CAMPAIGN_DETAILS)">
                        <i class="app-icon icon icon-edit icon-sm"></i>
                        <span class="edit-label">{{ 'common.edit' | translate }}</span>
                    </div>
                </div>

                <!-- Campaign Dates in Draft & Ongoing -->
                <div
                    *ngIf="specialOffer.status === specialOfferStatus.DRAFT || specialOffer.status === specialOfferStatus.ONGOING
                        || specialOffer.status === specialOfferStatus.UPCOMING"
                    class="dotted-border-box dates-box">
                    <div
                        *ngIf="
                        specialOffer.status === specialOfferStatus.DRAFT ||
                        specialOffer.status === specialOfferStatus.ONGOING ||
                        specialOffer.status === specialOfferStatus.UPCOMING
                        "
                        role="button"
                        tabindex="0"
                        class="edit-container"
                        (click)="editSection(specialOfferRoutes.CAMPAIGN_DETAILS , specialOffer.status)">
                        <i class="app-icon icon icon-edit icon-sm"></i>
                        <span class="edit-label">{{ 'common.edit' | translate }}</span>
                    </div>
                    <div class="campaign-dates">
                        <div class="date-item">
                            <span class="text-secondary">{{ 'specialOffers.preview.information.startDate' | translate }} </span>
                            <span HJSuppress class="fw-semibold">{{ specialOffer.startDate | localizedDate}}</span>
                        </div>
                        <div class="date-item">
                            <span class="text-secondary">{{ 'specialOffers.preview.information.endDate' | translate }}</span>
                            <span HJSuppress class="fw-semibold text-danger">{{ countdown$ | async }}</span>
                        </div>
                    </div>
                </div>

                <!-- Dealer and Industry details -->
                <div
                    [ngClass]="{
                    'content-box': true,
                    'dotted-border-box': specialOffer.status === specialOfferStatus.DRAFT || specialOffer.status === specialOfferStatus.UPCOMING,
                    'financial-header': true}">
                    <div
                        *ngIf="specialOffer.status === specialOfferStatus.DRAFT ||
                        specialOffer.status === specialOfferStatus.UPCOMING"
                        class="edit-container"
                        role="button"
                        tabindex="0"
                        (click)="editSection(specialOfferRoutes.CAMPAIGN_DETAILS)">
                        <i class="app-icon icon icon-edit icon-sm"></i>
                        <span class="edit-label">{{ 'common.edit' | translate }}</span>
                    </div>
                    <div class="financial-details">
                        <div class="dealer-box">
                            <i class="app-icon icon icon-user icon-xxxl me-3"></i>
                            <div style="display: block">
                                <span class="box-title text-secondary">{{ 'specialOffers.preview.information.dealer' | translate }}</span>
                                <div HJSuppress class="fw-semibold">{{ specialOffer.dealerName }}</div>
                            </div>
                        </div>
                        <div class="domain-box">
                            <i class="app-icon icon icon-vehicle-request icon-xxxl me-3"></i>
                            <div style="display: block">
                                <span class="box-title text-secondary">{{ 'specialOffers.preview.information.industry' | translate }}</span>
                                <div HJSuppress class="fw-semibold">{{ specialOffer.campaignType }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Image-->
                <div class="campaign-image-container">
                    <img
                        HJSuppress
                        *ngIf="specialOffer?.campaignImageSrc"
                        [src]="specialOffer.campaignImageSrc"
                        alt="Campaign product image"
                        class="img img-fluid" />
                </div>

                <!-- Financial Details -->
                <div
                    [ngClass]="{
                    'content-box': true,
                    'dotted-border-box': specialOffer.status === specialOfferStatus.DRAFT
                    || specialOffer.status === specialOfferStatus.UPCOMING,
                    'financial-header': true}">
                    <div
                        *ngIf="specialOffer.status === specialOfferStatus.DRAFT || specialOffer.status === specialOfferStatus.UPCOMING"
                        class="edit-container"
                        role="button"
                        tabindex="0"
                        (click)="editSection(specialOfferRoutes.FINANCING_DETAILS)">
                        <i class="app-icon icon icon-edit icon-sm"></i>
                        <span class="edit-label">{{ 'common.edit' | translate }}</span>
                    </div>
                    <div class="financial-details">
                        <div class="financial-item">
                            <span class="financial-label">{{ 'specialOffers.preview.information.downpayment' | translate }}</span>
                            <span HJSuppress class="financial-value">{{ specialOffer.minimumDownPayment }} {{specialOffer.currencyCode}}</span>
                        </div>
                        <div class="financial-item">
                            <span class="financial-label">{{ 'specialOffers.preview.information.interestRate' | translate }}</span>
                            <span HJSuppress class="financial-value">{{ specialOffer.interest }} %</span>
                        </div>
                        <div class="financial-item">
                            <span class="financial-label">{{ 'specialOffers.preview.information.financingPeriod' | translate }}</span>
                            <span HJSuppress class="financial-value">
                                {{ specialOffer.financingPeriod }}
                                {{ (specialOffer.financingPeriod === 1 ? 'specialOffers.wizard.financingDetails.month' : 'specialOffers.wizard.financingDetails.months') | translate }}
                            </span>
                        </div>
                        <div class="financial-item">
                            <span class="financial-label">
                                {{'specialOffers.preview.information.monthlyInstallment' | translate}}</span>
                            <span HJSuppress class="financial-value">{{ specialOffer.estMonthlyInstallment }} {{specialOffer.currencyCode}}</span>
                        </div>
                    </div>
                </div>

                <!-- Product Description-->
                <div
                    [ngClass]="{
                    'content-box': true,
                    'dotted-border-box': specialOffer.status === specialOfferStatus.DRAFT
                    || specialOffer.status === specialOfferStatus.UPCOMING,
                    'product-description': true}">
                    <div
                        *ngIf="specialOffer.status === specialOfferStatus.DRAFT || specialOffer.status === specialOfferStatus.UPCOMING"
                        class="edit-container"
                        role="button"
                        tabindex="0"
                        (click)="editSection(specialOfferRoutes.CAMPAIGN_DESCRIPTION)">
                        <i class="app-icon icon icon-edit icon-sm"></i>
                        <span class="edit-label">{{ 'common.edit' | translate }}</span>
                    </div>
                    <div class="product-description-content">
                        <span HJSuppress [innerHtml]="specialOffer.description"></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- Campaign documents-->
        <div class="card">
            <div class="card-body">
                <div
                    *ngIf="specialOffer.status === specialOfferStatus.DRAFT ||
                    specialOffer.status === specialOfferStatus.ONGOING ||
                    specialOffer.status === specialOfferStatus.UPCOMING"
                    class="edit-container"
                    role="button"
                    tabindex="0"
                    (click)="editSection(specialOfferRoutes.CAMPAIGN_DESCRIPTION , specialOffer.status)">
                    <i class="app-icon icon icon-edit icon-sm"></i>
                    <span class="edit-label">{{ 'common.edit' | translate }}</span>
                </div>
                <div class="documents-header">
                    <h3 class="documents-title">{{ 'specialOffers.preview.information.documents' | translate }}</h3>
                    <button class="btn m-outline-btn" (click)="downloadAllDocuments()">
                        <i class="app-icon icon icon-download icon-xl me-3"></i>
                        <span>{{ 'specialOffers.preview.information.downloadAll' | translate }}</span>
                    </button>
                </div>

                <div class="documents-list">
                    <div class="document-item" *ngFor="let doc of specialOffer.campaignDocuments">
                        <div class="document-icon">
                            <kendo-icon HJSuppress [name]="getFileTypeIcon(doc.documentName)" class="file-icon"></kendo-icon>
                        </div>
                        <div HJSuppress class="document-name">{{ doc.documentName }}</div>
                        <button class="btn m-outline-btn" (click)="downloadDocument(doc)">
                            <i class="app-icon icon icon-download icon-xl"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card client-segmentation-card">
        <div class="client-segmentation-section">
            <div class="client-segmentation">
                <div class="client-segmentation-header">
                    <div class="d-flex flex-column">
                        <div
                            *ngIf="specialOffer.status === specialOfferStatus.DRAFT ||
                            specialOffer.status === specialOfferStatus.ONGOING ||
                            specialOffer.status === specialOfferStatus.UPCOMING"
                            class="edit-container align-self-end"
                            role="button"
                            tabindex="0"
                            (click)="editSection(specialOfferRoutes.CLIENT_SEGMANTATION , specialOffer.status)">
                            <i class="app-icon icon icon-edit icon-sm"></i>
                            <span class="edit-label">{{ 'common.edit' | translate }}</span>
                        </div>
                        <div>
                            <i class="app-icon icon icon-warning-circle icon-xl me-2" style="vertical-align: middle"></i>
                            <span class="segmentation-title">
                                {{'specialOffers.preview.information.clientSegmentation.title' | translate}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="segmentation-content">
                    <p>{{ 'specialOffers.preview.information.clientSegmentation.choiseText' | translate }}</p>
                    <ul>
                        <li HJSuppress *ngIf="specialOffer.segmentItems">
                            <span>{{ 'specialOffers.preview.information.clientSegmentation.industryActivityText' | translate }} {{ specialOffer.segmentItemType }}</span>
                            <span HJSuppress *ngFor="let segmentItem of specialOffer.segmentItems; ; let isLast=last" class="text-primary">
                                {{ segmentItem.dictionarySegmentItemName }}
                                <span HJSuppress *ngIf="!isLast">,</span>
                            </span>
                        </li>
                        <li HJSuppress *ngIf="specialOffer.maximumPaymentDelay">
                            <span HJSuppress>{{ 'specialOffers.preview.information.clientSegmentation.paymentRequirementsText' | translate }} {{ specialOffer.maximumPaymentDelay }}</span>
                        </li>
                        <li HJSuppress *ngIf="specialOffer.periodUntilTermination">
                            <span HJSuppress>{{ 'specialOffers.preview.information.clientSegmentation.periodUntilTerminationText' | translate : { periodUntilTermination: specialOffer.periodUntilTermination } }}</span>
                        </li>
                    </ul>
                </div>

            </div>
            <p *ngIf="!specialOffer.startDate || !specialOffer.endDate" class="text-danger">
                {{ 'specialOffers.preview.information.clientSegmentation.duplicateInfoText' | translate }}
            </p>
            <p class="note">{{ 'specialOffers.preview.information.clientSegmentation.noteText' | translate }}</p>
            <div class="campaign-actions" *ngIf="specialOffer.status === specialOfferStatus.DRAFT">
                <button class="btn primary-btn"
                    (click)="publishCampaign(specialOfferStatus.ONGOING)"
                    [disabled]="!specialOffer.startDate || !specialOffer.endDate">
                    {{ 'specialOffers.preview.information.clientSegmentation.publish' | translate }}
                    <i class="app-icon icon icon-chevron-right icon-lg ms-2"></i>
                </button>
                <button class="btn custom-delete-btn"
                    *ngIf="!stateSignalItem.data.isNewCamapign" (click)="deleteCampaign()">
                    {{ 'specialOffers.preview.information.clientSegmentation.delete' | translate }}
                    <i class="app-icon icon icon-delete icon-lg ms-2"></i>
                </button>
                <button class="btn outline-btn"
                    *ngIf="stateSignalItem.data.isNewCamapign"
                    (click)="publishCampaign(specialOfferStatus.DRAFT)">
                    {{ 'specialOffers.preview.information.clientSegmentation.saveAsDraft' | translate }}
                    <i class="app-icon icon icon-save icon-lg ms-2"></i>
                </button>
            </div>
            <div class="campaign-actions" *ngIf="specialOffer.status === specialOfferStatus.ONGOING">
                <button class="btn custom-stop-btn"
                    (click)="stopCampaign()">
                    {{ 'specialOffers.preview.information.clientSegmentation.stop' | translate }}
                    <i class="app-icon icon icon-clock icon-lg ms-2"></i>
                </button>
            </div>
            <div class="campaign-actions" *ngIf="specialOffer.status === specialOfferStatus.ENDED">
                <button class="btn primary-btn"
                    (click)="duplicateCampaign()">
                    {{ 'specialOffers.preview.information.clientSegmentation.duplicate' | translate }}
                    <i class="app-icon icon icon-copy icon-lg ms-2"></i>
                </button>
            </div>
            <div class="campaign-actions" *ngIf="specialOffer.status === specialOfferStatus.UPCOMING">
                <button class="btn primary-btn"
                    (click)="publishCampaign(specialOffer.status)">
                    {{ 'specialOffers.preview.information.clientSegmentation.save' | translate }}
                    <i class="app-icon icon icon-chevron-right icon-lg ms-2"></i>
                </button>
            </div>
        </div>
    </div>
</div>
